import { AddressDTO } from "./addressDTO";

export class InventoryDTO{
    public id?:number;
    public businessId!:string;
    public propertyId!:string;
    public clientId?:number;
    public stateId?:number;
    public countyId?:number;
    public taxYear?:number;
    public defendant?:string;
    public address?:AddressDTO;
    public rawData?:string;
    public status?:number;
    public activePropertyId?:number;
    public addedByUser?:string;
    public added?:string;
    public lastEditedByUser?:string;
    public edited?:string;
}